export default "__VITE_ASSET__DhCe$ao4__"